import { ValidationHelper } from '../../../../../helpers';
import { BaseMapLayer } from './baseMapLayer';
// Class for custom maptiler base layer
export class MapTilerBaseMapLayer extends BaseMapLayer {
    constructor(id, name, url, type, isActive, apiKey, thumbnail, attribution) {
        super(id, name, url, type, isActive, thumbnail);
        this.apiKey = apiKey;
        this.attribution = attribution;
        this.validate();
    }
    /**
     * Check if all mandatory properties exist
     * @returns A boolean value.
     */
    existProperties() {
        const existProperties = super.existProperties();
        return (existProperties
            && ValidationHelper.existProperty(this.apiKey));
    }
    /**
     * If the properties are of the right type
     * property is a boolean, then return true.
     *
     * @returns The return value is a boolean.
     */
    sameTypeProperties() {
        const sameTypeProperties = super.sameTypeProperties();
        return (sameTypeProperties
            && ValidationHelper.sameTypeProperty(this.apiKey, 'string'));
    }
}
//# sourceMappingURL=mapTilerBaseMapLayer.js.map